import { Typography } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useWatch } from 'antd/es/form/Form'
import ReferenceRules from '../../../../pages/settings/company/keyFigures/formulas/components/ReferenceRules/ReferenceRules'

const FormulaReferenceRulesField: React.FC = () => {
  const { t } = useTranslation()
  const variableType = useWatch('type')

  return (
    <>
      <Typography.Text>{t('global:referenceRules')}</Typography.Text>
      <ReferenceRules variableType={variableType} />
    </>
  )
}

export default FormulaReferenceRulesField
